<app-breadcrumb *ngIf="!dialogRef" [master]="'Rejestracje'" [parentName]="'Rejestracje'" [name]="'Dodaj wiele '"></app-breadcrumb>
<div class="registration-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="registrationForm">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="!dialogRef">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!registrationFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane rejestracji</h3>
          </div>

          <div fxLayout="row" *ngIf="!ofwcaObject">
            <app-dict-ofwcas fxFlex="100" label="OFWCA" [control]="ofwcaControl" [required]="true" (selectedOfwca)="ofwcaChanged($event)"></app-dict-ofwcas>
          </div>

          <div fxLayout="row" *ngIf="ofwcaObject">
              <app-detail fxFlex="100" header="OFWCA" [value]="ofwcaObject.fullName"></app-detail>
          </div>

          <div fxLayout="row">
            <mat-slide-toggle fxFlex="100" color="accent" formControlName="showAllContracts">Pokaż wszystkie umowy</mat-slide-toggle>
          </div>

          <div fxLayout="row" *ngIf="showAllContracts">
            <app-dict-all-contracts
              fxFlex="100" label="Umowa"
              [control]="contractControl" [required]="true"
              (selectedContract)="contractChanged($event)" [showOwnerName]="true"
              [showStatus]="true" [filterRegistrationType]="true"
            ></app-dict-all-contracts>
          </div>

          <div fxLayout="row" *ngIf="!showAllContracts && !contractObject">
            <app-dict-contracts fxFlex="100" label="Umowa" [control]="contractControl" [required]="true" [contracts]="ofwcaContracts"
                                (selectedContract)="contractChanged($event)" [showOwnerName]="true"
                                [showStatus]="true"></app-dict-contracts>
          </div>

          <div fxLayout="column" *ngIf="contractObject">
            <app-detail fxFlex="100" header="Umowa" [value]="contractObject.type.name + ' (nr: ' + contractObject.number + '), zawarta '
                        + (contractObject.concludeDate | date:'y-MM-dd')"></app-detail>
            <mat-error *ngIf="contractControl.hasError('backendError')">{{contractControl.getError('backendError')}}</mat-error>
          </div>

<!--          <div fxLayout="row">-->
<!--            <h5 *ngIf="selectedContract?.company?.key === COMPANY_ASF">-->
<!--              Wszystkie nowe rejestracje należy dodawać pod umową z ASF PREMIUM, z wyjątkiem Balcia-->
<!--            </h5>-->
<!--          </div>-->

          <div fxLayout="row">
            <app-dict-insurance-companies fxFlex="100" label="TU" [required]="true" [control]="insuranceCompanyControl" [multiple]="true"
                                          [companyId]="contractCompanyId"
                                          (selectedInsuranceCompanies)="insuranceCompanyChanged($event)"
                                          [hideInactive]="true" [hideChildren]="true"
                                          [forceShowPzu]="selectedContract?.type?.key === CONTRACT_TYPE_PROFIT"
                                          [forceShowBalcia]="selectedContract?.type?.key === CONTRACT_TYPE_PROFIT"
                                          [forceHidePzu]="selectedContract?.company?.key === COMPANY_ASF"
                                          [allSelect]="true"
            ></app-dict-insurance-companies>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <app-dict fxFlex="100" label="Co jest potrzebne?" [required]="true" [control]="whatIsNeededControl" dictType="registration_what_is_needed"></app-dict>
<!--            <app-dict fxFlex="50" label="Podwójna rejestracja" [required]="true" [control]="doubleRegistrationControl" dictType="double_registration"></app-dict>-->
          </div>
          <div fxLayout="row"  fxLayoutGap="15px">
            <mat-error fxFlex="100" *ngIf="doubleRegistrationControl.hasError('backendError')">{{doubleRegistrationControl.getError('backendError')}}</mat-error>
          </div>

        </mat-card>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="availableSalesProfiles">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Profile/systemy sprzedażowe</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="salesProfilesControlEH.enabled">
              <app-dict fxFlex="100" label="Ergo hestia" [required]="true" [multiple]="true" [control]="salesProfilesControlEH"
                        [dictTypeSubject]="salesProfilesDictTypeSubjectEH"></app-dict>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="salesProfilesControlEHL.enabled">
              <app-dict fxFlex="100" label="Ergo hestia życie" [required]="true" [multiple]="true" [control]="salesProfilesControlEHL"
                        [dictTypeSubject]="salesProfilesDictTypeSubjectEHL"></app-dict>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="salesProfilesControlG.enabled">
              <app-dict fxFlex="100" label="Generali " [required]="true" [multiple]="true" [control]="salesProfilesControlG"
                        [dictTypeSubject]="salesProfilesDictTypeSubjectG"></app-dict>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="salesProfilesControlGL.enabled" >
              <app-dict fxFlex="100" label="Generali życie" [required]="true" [multiple]="true" [control]="salesProfilesControlGL"
                        [dictTypeSubject]="salesProfilesDictTypeSubjectGL"></app-dict>
            </div>
<!--            <div fxLayout="row" fxLayoutGap="15px" *ngIf="salesProfilesControlCo.enabled" >-->
<!--              <app-dict fxFlex="100" label="Compensa" [required]="true" [multiple]="true" [control]="salesProfilesControlCo"-->
<!--                        [dictTypeSubject]="salesProfilesDictTypeSubjectCo"></app-dict>-->
<!--            </div>-->


          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="chronieInsuranceCompanies">-->
<!--        <div fxFlex="100">-->
<!--          <mat-card>-->
<!--            <div fxLayout="row">-->
<!--              <h3>Chronie.pl</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" *ngIf="!selectedOfwca || !selectedOfwca.chronieLogin">-->
<!--              <div fxFlex="100">-->
<!--                <mat-form-field fxFlex="100">-->
<!--                  <mat-label>Login</mat-label>-->
<!--                  <input [required]="true" matInput placeholder="adres@asf24.pl" formControlName="chronieLogin">-->
<!--                  <mat-error *ngIf="registrationForm.get('chronieLogin').hasError('email')">Podaj prawidłowy adres email</mat-error>-->
<!--                  <mat-error *ngIf="registrationForm.get('chronieLogin').hasError('backendError')">-->
<!--                    {{registrationForm.get('chronieLogin').getError('backendError')}}-->
<!--                  </mat-error>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div fxLayout="row" *ngIf="!(!selectedOfwca || !selectedOfwca.chronieLogin)">-->
<!--              <app-detail fxFlex="100" header="Login" [value]="selectedOfwca.chronieLogin"></app-detail>-->
<!--            </div>-->
<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requireLink4Data">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane do rejestracji Link 4</h3>
            </div>


            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>NIP</mat-label>
                  <input [required]="true" matInput placeholder="NIP" formControlName="registrationNipLink4">
                  <mat-error *ngIf="registrationForm.get('registrationNipLink4').hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Wlaściciel OFWCA Partner (Imię i Nazwisko, jeśli nie ma Właściciela to imię i nazwisko Koordynatora)</mat-label>
                  <input [required]="true" matInput placeholder="Wlaściciel OFWCA Partner (Imię i Nazwisko, jeśli nie ma Właściciela to imię i nazwisko Koordynatora)" formControlName="registrationOfwcaOwner">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Nazwa Firmy Partner</mat-label>
                  <input [required]="true" matInput placeholder="Nazwa Firmy Partner" formControlName="registrationCompanyName">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Email podstawowy Partnera</mat-label>
                  <input [required]="true" matInput placeholder="Email podstawowy Partnera" formControlName="registrationPartnerEmail">
                  <mat-error *ngIf="registrationForm.get('registrationPartnerEmail').hasError('email')">Podaj prawidłowy adres email</mat-error>
                </mat-form-field>
              </div>
            </div>

            <app-address-form title="Adres Placówki" [addressForm]="registrationFacilityAddressGroup"></app-address-form>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requirePzuData">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3 [fxFlex]="'88'">Dane do weryfikacji PZU</h3>

              <div  fxLayout="row" fxFlex="5" class="button-exit" >
                <button (click)="downloadPartner()"  mat-icon-button color="primary" matTooltip="Skopiuj dane partnera"><mat-icon>download</mat-icon></button>
              </div>
            </div>

            <app-address-form title="Adres biura/Miejsce pracy OFWCA"  [addressForm]="registrationFacilityAddressPzuGroup" ></app-address-form>

            <mat-card>
              <div fxLayout="row">
                <h3>Dane podmiotu sprzedaży</h3>
              </div>

              <div fxLayout="row">
                <div fxFlex="100">
                  <mat-form-field fxFlex="100">
                    <mat-label>Nazwa agencji</mat-label>
                    <input [required]="true" matInput placeholder="Nazwa agencji" formControlName="registrationAgencyName">
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row">
                <div fxFlex="100">
                  <mat-form-field fxFlex="100">
                    <mat-label>NIP</mat-label>
                    <input [required]="true" matInput placeholder="NIP" formControlName="registrationNipPzu">
                    <mat-error *ngIf="registrationForm.get('registrationNipPzu').hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row">
                <app-dict fxFlex="100" label="Segment" [required]="true" [control]="registrationSegmentControl" dictType="segment_type"></app-dict>
              </div>

            </mat-card>
          </mat-card>
        </div>

      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requirePzuData || requireLink4Data || requirePzuLife">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3 >Dane rejestracji</h3>

            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Email</mat-label>
                <input matInput placeholder="adres@asf.com.pl" formControlName="additionalEmail" [required]="false">
                <mat-error *ngIf="registrationForm.get('additionalEmail').hasError('email')">Podaj prawidłowy adres email</mat-error>
              </mat-form-field>
            </div>



            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Numer telefonu</mat-label>
                <input matInput placeholder="+48 500 200 300" formControlName="additionalPhone" [required]="false" prefix="+48" mask=" 000 000 000">
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requireCompensaData">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane do rejestracji Compensa</h3>
            </div>

<!--            <div fxLayout="row">-->
<!--              <app-dict fxFlex="100" label="Biuro Compensa" [required]="true" [control]="registrationCompensaOfficeControl"-->
<!--                        [dictType]="selectedContract?.type.key === CONTRACT_TYPE_PROFIT ? 'compensa_office_profit' : 'compensa_office'"></app-dict>-->
<!--            </div>-->
            <div fxLayout="row">
              <app-dynamic-dict fxFlex="100" label="Biuro Compensa" [required]="true" [control]="registrationCompensaOfficeNewControl" [dictType]="selectedContract?.type.key === CONTRACT_TYPE_PROFIT ? DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT : DYNAMIC_DICTIONARY_COMPENSA_OFFICE"></app-dynamic-dict>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requireCompensaLifeData">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane do rejestracji Vienna Life</h3>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" label="Biuro" [required]="true" [control]="registrationCompensaLifeOfficeControl"
                        [dictType]="'compensa_office_life'"></app-dict>
            </div>
          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requireTrasti">-->
<!--        <div fxFlex="100">-->
<!--          <mat-card>-->
<!--            <div fxLayout="row">-->
<!--              <h3>Dane do rejestracji Trasti</h3>-->
<!--            </div>-->


<!--            <div fxLayout="row">-->
<!--              <div fxFlex="100">-->
<!--                <mat-form-field fxFlex="100">-->
<!--                  <mat-label>Unikatowy adres email</mat-label>-->
<!--                  <input [required]="true" matInput placeholder="adres@asf24.pl" formControlName="trastiEmail">-->
<!--                  <mat-error *ngIf="registrationForm.get('trastiEmail').hasError('email')">Podaj prawidłowy adres email</mat-error>-->
<!--                  <mat-error *ngIf="registrationForm.get('trastiEmail').hasError('backendError')">-->
<!--                    {{registrationForm.get('trastiEmail').getError('backendError')}}-->
<!--                  </mat-error>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--            </div>-->

<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!registrationFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
